var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoginCode = function SvgLoginCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 343,
    height: 145,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#login-code_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#03070A",
    d: "m131.397 95.991.996 26.341h-2.425v2.982h6.778v-2.982h-1.977l.141-26.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03070A",
    d: "M128.781 118.107c1.032 0 1.868.835 1.868 1.864v7.704a1.865 1.865 0 0 1-1.868 1.863 1.865 1.865 0 0 1-1.868-1.863v-7.704c0-1.029.837-1.864 1.868-1.864M138.246 118.107c1.032 0 1.868.835 1.868 1.864v7.704a1.865 1.865 0 0 1-1.868 1.863 1.865 1.865 0 0 1-1.868-1.863v-7.704c0-1.029.836-1.864 1.868-1.864"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C8599",
    d: "m153.441 79.58-38.36-1.74 5.978-2.734 33.627.497zM.5 83.443l4.633-1.74 143.824 3.728 5.979-2.734-2.491 16.898L38.198 87.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03070A",
    d: "m37.49 93.258.709-5.808 114.246 12.145-.623 8.573z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03070A",
    d: "M114.334 110.404c6.534 0 11.831-5.619 11.831-12.55 0-6.93-5.297-12.548-11.831-12.548-6.535 0-11.832 5.618-11.832 12.549 0 6.93 5.297 12.549 11.832 12.549"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C8599",
    d: "M114.334 104.316c4.815 0 8.718-3.894 8.718-8.698 0-4.803-3.903-8.697-8.718-8.697-4.815 0-8.718 3.894-8.718 8.697 0 4.804 3.903 8.698 8.718 8.698"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03070A",
    d: "m211.603 95.991-.996 26.341h2.425v2.982h-6.778v-2.982h1.977l-.141-26.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03070A",
    d: "M214.219 118.107a1.866 1.866 0 0 0-1.868 1.864v7.704c0 1.029.836 1.863 1.868 1.863a1.865 1.865 0 0 0 1.868-1.863v-7.704a1.866 1.866 0 0 0-1.868-1.864M204.754 118.107a1.866 1.866 0 0 0-1.868 1.864v7.704c0 1.029.836 1.863 1.868 1.863a1.865 1.865 0 0 0 1.868-1.863v-7.704a1.866 1.866 0 0 0-1.868-1.864"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C8599",
    d: "m189.559 79.58 38.36-1.74-5.978-2.734-33.628.497zM175.829 74.226l-1.743-38.269-2.74 5.964.498 33.547zM342.5 83.443l-4.633-1.74-143.824 3.728-5.979-2.734 2.491 16.898L304.802 87.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03070A",
    d: "m305.511 93.258-.709-5.808-114.246 12.145.622 8.573z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03070A",
    d: "M228.666 110.404c6.534 0 11.831-5.619 11.831-12.55 0-6.93-5.297-12.548-11.831-12.548-6.535 0-11.832 5.618-11.832 12.549 0 6.93 5.297 12.549 11.832 12.549"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C8599",
    d: "M228.666 104.316c4.815 0 8.719-3.894 8.719-8.698 0-4.803-3.904-8.697-8.719-8.697-4.815 0-8.718 3.894-8.718 8.697 0 4.804 3.903 8.698 8.718 8.698M193.233 74.813l-.565 4.156-.294 22.375a22.502 22.502 0 0 1-.603 4.905c-1.091 4.647-3.639 8.874-7.403 11.938-3.415 2.783-8.073 4.891-14.238 4.518-16.44-.994-17.892-14.952-17.892-14.952l.621-25.312.084-3.472.747-6.263s1.993-17.644 20.426-17.147c18.432.497 19.117 19.254 19.117 19.254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "m157.676 68.978 3.736-5.964 4.733-1.49h16.191l3.985 1.49 3.617 5.964-6.606-2.982h-18.531z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03070A",
    d: "m171.378 111.855.639 16.898h-1.556v1.913h4.348v-1.913h-1.268l.091-16.898z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03070A",
    d: "M169.699 126.043c.662 0 1.199.535 1.199 1.196v4.941c0 .661-.537 1.196-1.199 1.196a1.197 1.197 0 0 1-1.198-1.196v-4.941c0-.661.537-1.196 1.198-1.196M175.772 126.043c.662 0 1.198.535 1.198 1.196v4.941c0 .661-.536 1.196-1.198 1.196a1.197 1.197 0 0 1-1.199-1.196v-4.941c0-.661.537-1.196 1.199-1.196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C8599",
    d: "M166.741 57.86 163.3 70.22l.663.184 3.441-12.36zM182.345 59.832l-.675.133 2.479 12.587.676-.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-code_svg__b)",
    d: "M314.847 35.998c0 .233-.261.42-.586.42H213.586c-.325 0-.586-.187-.586-.42 0-.232.261-.419.586-.419h100.675c.325 0 .586.187.586.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#445C75",
    d: "M274.865 39.927a4.469 4.469 0 0 1-4.474-4.464A4.469 4.469 0 0 1 274.865 31a4.469 4.469 0 0 1 4.474 4.463 4.469 4.469 0 0 1-4.474 4.464"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-code_svg__c)",
    d: "M28.116 53.998c0 .233.261.42.587.42h100.674c.325 0 .586-.187.586-.42 0-.232-.261-.419-.586-.419H28.703c-.326 0-.587.187-.587.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#445C75",
    d: "M68.098 57.927a4.469 4.469 0 0 0 4.474-4.464A4.469 4.469 0 0 0 68.098 49a4.469 4.469 0 0 0-4.474 4.463 4.469 4.469 0 0 0 4.474 4.464"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-code_svg__b",
    x1: 314.963,
    x2: 212.963,
    y1: 36,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#445C75",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#445C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#445C75",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-code_svg__c",
    x1: 28,
    x2: 130,
    y1: 54,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#445C75",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#445C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#445C75",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "login-code_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h342v145H.5z"
  })))));
};
export default SvgLoginCode;